{
  "add_multiple": "Add multiple",
  "add_options": "Add options",
  "enter_one_option_per_line": "Enter one option per line",
  "bulk_options_placeholder": "Yes\nNo\nMaybe\netc...",
  "accept_invitation": "Accept invitation",
  "accepts_formats": "Accepts {formats}",
  "access": "Access",
  "access_denied": "Access denied",
  "access_granted": "Access granted",
  "actions": "Actions",
  "activity": "Activity",
  "add": "Add",
  "add_comment": "Add comment",
  "add_contact": "Add contact",
  "add_description": "Add description",
  "add_details": "Add details",
  "add_field": "Add field",
  "add_files": "Add files",
  "add_image": "Add image",
  "add_image_cta": "Choose an image",
  "add_item": "Add item",
  "add_option": "Add option",
  "add_record": "Add record",
  "agree_with_privacy_policy": "Privacy Policy",
  "agree_with_terms_of_service": "Terms of Service",
  "all": "All",
  "all_file_types_supported": "All file types are supported",
  "all_categories": "All categories",
  "all_time": "All time",
  "amount": "Amount",
  "and": "and",
  "anonymous": "Anonymous",
  "answer": "Answer",
  "application": "Application",
  "apply": "Apply",
  "apply_to": "Apply to",
  "archive": "Archive",
  "assign_to": "Assign to",
  "attach": "Attach",
  "attention": "Attention",
  "author": "Author",
  "automated": "Automated",
  "automation": "Automation",
  "back": "Back",
  "beta": "Beta",
  "background": "Background",
  "balances": "Balances",
  "budget": "Budget",
  "calculation": "Calculation",
  "calendar": "Calendar",
  "cancel": "Cancel",
  "categories": "Categories",
  "change": "Change",
  "change_password": "Change password",
  "changes_saved_successfully": "The changes were saved successfully",
  "changed": "Changed",
  "chat_in": "Chat in",
  "choose_file_cta": "Choose a file",
  "choose_color": "Choose color",
  "choose_emoji": "Choose emoji",
  "choose_field": "Choose field",
  "choose_section": "Choose section",
  "choose_table": "Choose table",
  "choose_template": "Choose template",
  "choose_type": "Choose type",
  "clear_all": "Clear all",
  "click_to_show_pages": "Click to show pages",
  "click_to_view_answers": "Click to view answers",
  "close": "Close",
  "co_owners": "Co-owners",
  "code": "Code",
  "collapse": "Collapse",
  "fullscreen": "Fullscreen",
  "fullscreen_exit": "Exit fullscreen",
  "toggle_pages_panel": "Toggle pages panel",
  "colors": "Colors",
  "column": "Column",
  "columns": "Columns",
  "comment": "Comment",
  "comments": "Comments",
  "company": "Company",
  "comparison": "Comparison",
  "complete": "Complete",
  "completed_percent": "{percent}% completed",
  "condition": "Condition",
  "configuration": "Configuration",
  "confirm": "Confirm",
  "confirmation": "Confirmation",
  "continue": "Continue",
  "or": "or",
  "conversion": "Conversion",
  "copied": "Copied",
  "copy_failed": "Could not copy",
  "copy_from": "Copy from",
  "copy_link": "Copy link",
  "create": "Create",
  "create_new": "Create new",
  "create_new_item": "Create new item",
  "create_shareable_link": "Create shareable link",
  "created": "Created",
  "created_by": "Created by",
  "currency": "Currency",
  "custom": "Custom",
  "custom_period": "Custom period…",
  "custom_period_description": "Choose start and end dates, with or regardless of year",
  "choose_period": "Choose period",
  "filter_type": "Filter type",
  "any_year": "Any year",
  "period_group_exact": "Exact dates",
  "period_group_annual_this": "Current annual",
  "period_group_annual_future": "Future annual",
  "period_group_annual_past": "Past annual",
  "period_type_calendar": "Calendar dates",
  "period_type_calendar_caption": "Filter using exact dates including year",
  "period_type_annual": "Annual events",
  "period_type_annual_caption": "Find birthdays, anniversaries, and other dates regardless of year",
  "period_hint_exact": "Filtered by exact dates",
  "period_hint_annual": "All annual events included",
  "period_start_date": "Period start date",
  "period_start_dates": "Period start dates",
  "danger_zone": "Danger zone",
  "date": "Date",
  "date_after": "After",
  "date_and_time": "Date and time",
  "date_before": "Before",
  "date_effective_from": "Date",
  "date_effective_to": "End date",
  "date_format": "Date format",
  "date_from": "Date from",
  "date_from_short": "From",
  "date_placeholder_dd_mm_yyyy": "dd/mm/yyyy",
  "date_placeholder_dd_mm_yyyy_dot": "dd.mm.yyyy",
  "date_placeholder_mm_dd_yyyy": "mm/dd/yyyy",
  "date_placeholder_yyyy_mm_dd": "yyyy/mm/dd",
  "date_to": "Date to",
  "date_to_short": "To",
  "dates": "Dates",
  "day_of_month": "Day of month",
  "days": "Days",
  "hours": "Hours",
  "minutes": "Minutes",
  "minutes_unit": "min",
  "days_short": "{count}d",
  "delay": "Delay",
  "delete": "Delete",
  "remove": "Remove",
  "delete_confirm": "Are you sure you want to delete?",
  "deleted": "Deleted",
  "description": "Description",
  "description_enter_using_editor": "Describe using the editor",
  "details": "Details",
  "hide_details": "Hide details",
  "disable": "Disable",
  "disabled": "Disabled",
  "done": "Done",
  "dont_equal": "Don't equal",
  "duplicate": "Duplicate",
  "download": "Download",
  "download_pdf": "Download PDF",
  "document_preview_not_supported": "Preview is not available for this file format",
  "document_preview_download_instead": "Download the file to view it on your device",
  "document_preview_preparing": "Preview is being prepared…",
  "document_preview_preparing_description": "This usually takes a few seconds.",
  "document_preview_failed": "Preview could not be generated for this file",
  "draft": "Draft",
  "drag_to_reorder": "Drag to reorder",
  "due_date": "Due date",
  "duration": "Duration",
  "other_time": "Other time",
  "edit": "Edit",
  "edit_list": "Edit list",
  "edit_record": "Edit record",
  "edited": "Edited",
  "email_copied": "Email copied",
  "email_sent": "Email sent",
  "emoji": "Emoji",
  "employee_filter": "Employee filter",
  "empty": "Empty",
  "enable": "Enable",
  "enabled": "Enabled",
  "end_date": "End date",
  "english": "English",
  "enter_answer": "Enter answer",
  "equals": "Equals",
  "error": "Error",
  "exclude": "Exclude",
  "exit": "Exit",
  "export": "Export",
  "export_to_pdf": "Export to PDF",
  "export_to_xlsx": "Export to XLSX",
  "f_last": "F. Last",
  "file": "File",
  "file_dropzone_action": "Choose",
  "file_dropzone_prefix": "Drag & drop or",
  "file_dropzone_postfix": "to upload",
  "files": "Files",
  "filter": "Filter",
  "filter_apply": "Apply filter",
  "filter_clear": "Clear all filters",
  "filter_mode": "Filter mode",
  "filter_mode_date": "Full date",
  "filter_mode_day": "Day of the year",
  "filter_operator_custom": "Custom",
  "filter_preset_this_week": "This week",
  "filter_preset_last_week": "Last week",
  "filter_preset_this_month": "This month",
  "filter_preset_last_month": "Last month",
  "filter_preset_last_30_days": "Last 30 days",
  "filter_preset_last_3_months": "Last 3 months",
  "filter_preset_this_quarter": "This quarter",
  "filter_preset_last_quarter": "Last quarter",
  "filter_preset_this_year": "This year",
  "filter_preset_last_year": "Last year",
  "filter_preset_next_week": "Next week",
  "filter_preset_next_month": "Next month",
  "filter_preset_next_quarter": "Next quarter",
  "filter_preset_next_year": "Next year",
  "filter_preset_annual_this_week": "Annual events this week",
  "filter_preset_annual_this_month": "Annual events this month",
  "filter_preset_annual_this_quarter": "Annual events this quarter",
  "filter_preset_annual_next_week": "Annual events next week",
  "filter_preset_annual_next_month": "Annual events next month",
  "filter_preset_annual_next_quarter": "Annual events next quarter",
  "filter_preset_annual_last_week": "Annual events last week",
  "filter_preset_annual_last_month": "Annual events last month",
  "filter_preset_annual_last_quarter": "Annual events last quarter",
  "filter_preset_annual_last_30_days": "Annual events last 30 days",
  "filter_preset_annual_last_3_months": "Annual events last 3 months",
  "finish_date": "Finish date",
  "first_date": "First date",
  "first_day": "First day",
  "first_day_of_month": "First day of month",
  "first_last": "First Last",
  "folders": "Folders",
  "folder": "Folder",
  "friday": "Friday",
  "from_count_of": "{count} from {count_all}",
  "full_access": "Full access",
  "full_edit_access": "Full edit access",
  "funnel": "Funnel",
  "gender_female": "Female",
  "gender_male": "Male",
  "general": "General",
  "general_data": "General data",
  "generate_with_ai": "Generate with AI",
  "go_back": "Go back",
  "go_to_home": "Go to home",
  "good_afternoon": "Good afternoon",
  "good_evening": "Good evening",
  "good_morning": "Good morning",
  "good_night": "Good night",
  "group_period_by_day": "Daily",
  "group_period_by_month": "Monthly",
  "group_period_by_quarter": "Quarterly",
  "group_period_by_week": "Weekly",
  "group_period_by_year": "Yearly",
  "grouping": "Grouping",
  "help": "Help",
  "help_ai_translation_notice": "This article was translated with AI from the original English version. Please verify critical details against the English article.",
  "help_center": "Help center",
  "help_feedback_caption": "Choose one answer",
  "help_feedback_comment_dislike_prompt": "Help us improve this article. What were you trying to find, or what was missing?",
  "help_feedback_comment_like_prompt": "We're glad it helped! Is there anything we could make even better?",
  "help_feedback_comment_neutral_prompt": "Help us improve this article. What can we make clearer or more useful?",
  "help_feedback_comment_placeholder": "Share your comment",
  "help_feedback_rating_dislike": "Not helpful",
  "help_feedback_rating_like": "Helpful",
  "help_feedback_rating_neutral": "Partly helpful",
  "help_feedback_thank_you_text": "We use your feedback to improve the help center.",
  "help_feedback_thank_you_title": "Thanks for the feedback",
  "help_feedback_title": "Did this help?",
  "help_original_language_notice": "This article is currently shown in English because a translated version is not available yet.",
  "hide": "Hide",
  "hide_all": "Hide all",
  "hide_breakdown": "Hide breakdown",
  "history": "History",
  "hours_short": "{count}h",
  "image": "Image",
  "import": "Import",
  "in_days": "In {days}",
  "in_progress": "In progress",
  "include": "Include",
  "insert": "Insert",
  "invitation": "Invitation",
  "invitation_subject": "Invitation subject",
  "invite_from": "Invite from",
  "items": "Items",
  "label": "Label",
  "language": "Language",
  "language_default": "Default Language",
  "languages": "Languages",
  "last_day_of_month": "Last day of month",
  "last_first": "Last First",
  "last_seen": "Last seen",
  "later": "Later",
  "launch_plan": "Launch plan",
  "leave": "Leave",
  "leave_feedback": "Leave feedback",
  "library": "Library",
  "limits": "Limits",
  "link": "Link",
  "link_copied": "Link copied",
  "loading": "Loading",
  "location": "Location",
  "locations": "Locations",
  "log_in": "Log in",
  "log_in_with_google": "Log in with Google",
  "log_in_with_microsoft": "Log in with Microsoft",
  "log_in_with_sso": "Log in with SSO",
  "login": "Login",
  "logo": "Logo",
  "logout": "Log out",
  "manage_columns": "Manage columns",
  "manage_folders": "Manage folders",
  "manage_list": "Manage list",
  "maybe": "Maybe",
  "merge": "Merge",
  "message": "Message",
  "milestone": "Milestone",
  "minutes_short": "{count}m",
  "monday": "Monday",
  "month_end_day_selection": "For months with fewer than 31 days, the last day of the month will be automatically selected",
  "months": "Months",
  "months_short": "{count}mo",
  "more": "More",
  "more_export_options": "More export options",
  "more_filters": "More filters",
  "more_save_options": "More save options",
  "move_to": "Move to",
  "my_team": "My team",
  "n_a": "N/A",
  "name_pronunciation": "Pronounce name",
  "new_template": "New template",
  "next": "Next",
  "no": "No",
  "none": "None",
  "no_access": "No access",
  "no_records_yet": "There are no records yet",
  "no_results_for": "No results for “{query}”",
  "no_results_were_found": "No results were found",
  "no_title": "No title",
  "no_votes": "No votes",
  "non_anonymous": "Non-anonymous",
  "not_selected": "Not selected",
  "nothing_found": "Nothing found",
  "notifications": "Notifications",
  "now": "Now",
  "number_from_short": "From",
  "number_to_short": "To",
  "of": "{current} of {total}",
  "off": "Оff",
  "ok": "OK",
  "one_time": "One time",
  "only_me": "Only me",
  "only_me_admins_approvers": "Only me, approvers & admins",
  "open": "Open",
  "open_new_tab": "Open in a new tab",
  "open_results": "Open results",
  "option": "Option",
  "options": "Options",
  "options_at_least_one": "At least one option is required",
  "original": "Original",
  "original_file": "Original file",
  "other": "Other",
  "others": "others",
  "overview": "Overview",
  "owner": "Owner",
  "page": "Page",
  "page_of": "Page {page} of {total}",
  "pagination_pages": "Showing {from} to {to} of {total} in total",
  "participants": "Participants",
  "participation": "Participation",
  "password": "Password",
  "pending_change_waiting_approval": "Request is waiting for approval",
  "per_hour": "Hourly",
  "per_month": "Monthly",
  "per_quarter": "Quarterly",
  "per_week": "Weekly",
  "per_year": "Annually",
  "period": "Period",
  "privacy": "Privacy",
  "periods": "Periods",
  "last_year": "Last year",
  "period_full_year": "{year}",
  "period_h1": "H1 {year}",
  "period_h2": "H2 {year}",
  "period_q1": "Q1 {year}",
  "period_q2": "Q2 {year}",
  "period_q3": "Q3 {year}",
  "period_q4": "Q4 {year}",
  "permission_type_edit": "Can view and edit",
  "permission_type_view_and_manage_requests": "Can view and manage requests",
  "permission_type_none": "No access",
  "permission_type_view": "View only",
  "persons": "Persons",
  "pdf_loading": "Loading PDF...",
  "pdf_error_title": "Couldn't open the document",
  "pdf_error_description": "Something went wrong while opening the document. Please try reloading the page.",
  "pdf_load_failed": "Failed to load PDF",
  "pdf_not_selected": "No PDF selected",
  "pdf_render_failed": "Failed to render PDF",
  "pdf_unsupported_browser_title": "Your browser is not supported",
  "pdf_unsupported_browser_description": "We couldn't open the document. Your browser may be out of date — please update it or open the page in an up-to-date browser.",
  "photo": "Photo",
  "profile_photo": "Profile photo",
  "pick_a_date_range": "Pick a date range",
  "pin": "Pin",
  "policy": "Policy",
  "present_time": "Present",
  "preview": "Preview",
  "previous": "Previous",
  "progress": "Progress",
  "published": "Published",
  "quantity_short": "Quantity",
  "questionnaire": "Questionnaire",
  "questions": "Questions",
  "recent": "Recent",
  "recurring": "Recurring",
  "reorder": "Reorder",
  "reordering": "Reordering",
  "reply": "Reply",
  "reporting": "Reporting",
  "reports": "Reports",
  "request": "Request",
  "request_headers": "Request headers",
  "request_payload": "Request payload",
  "requested_document_not_found": "Oops! We couldn't find requested document",
  "requests": "Requests",
  "reset": "Reset",
  "response_rate": "Response rate",
  "responses": "Responses",
  "restore": "Restore",
  "results": "Results",
  "retry": "Retry",
  "review": "Review",
  "review_all": "Review all",
  "russian": "Russian",
  "saturday": "Saturday",
  "save": "Save",
  "save_and_continue": "Save & continue",
  "save_as_pdf": "Save as PDF",
  "scope": "Scope",
  "search": "Search",
  "search_in_profile": "Search in profile",
  "search_in_profile_placeholder": "Search in profile...",
  "search_by_name": "Search by name",
  "search_start_typing": "Start typing",
  "second_date": "Second date",
  "second_day": "Second day",
  "section": "Section",
  "security": "Security",
  "select": "Select",
  "select_all": "Select all",
  "select_fields": "Select fields",
  "sent": "Sent",
  "set_timeframe": "Set timeframe",
  "set_your_password": "Set your password",
  "settings": "Settings",
  "setup": "Setup",
  "shareable_link": "Shareable link",
  "show": "Show",
  "show_all": "Show all",
  "show_details": "Show details",
  "show_breakdown": "Show breakdown",
  "show_less": "Show less",
  "show_more": "Show more",
  "show_more_template": "Show {count} more",
  "show_results": "Show results",
  "sidebar_collapse": "Collapse sidebar",
  "sidebar_expand": "Expand sidebar",
  "sidebar_resize": "Resize sidebar",
  "skip": "Skip",
  "skype": "Skype",
  "snooze": "Snooze",
  "source": "Source",
  "sort_by_original_order": "Sort by original order",
  "sort_by_popularity": "Sort by popularity",
  "start_date": "Start date",
  "status": "Status",
  "status_completed": "Completed",
  "status_failed": "Failed",
  "status_cancelled": "Cancelled",
  "status_invited": "Invited",
  "waiting_for_external": "Pending completion",
  "skipped_by_condition": "Skipped by condition",
  "status_paused": "Paused",
  "status_pending_launch": "Pending launch",
  "status_running": "Running",
  "stay": "Stay",
  "submit": "Submit",
  "submit_the_request": "Submit the request",
  "summary": "Summary",
  "summary_permissions_description": "Content is displayed according to your permissions.",
  "sunday": "Sunday",
  "switch_off": "Switch off",
  "switch_on": "Switch on",
  "table": "Table",
  "table_of_contents": "Table of contents",
  "tax_id": "Tax Id",
  "telegram": "Telegram",
  "template": "Template",
  "templates": "Templates",
  "text": "Text",
  "timeframe": "Timeframe",
  "theme": "Theme",
  "dark_mode": "Dark theme",
  "light_mode": "Light theme",
  "system_mode": "Auto (system theme)",
  "color_mode": "Appearance",
  "thursday": "Thursday",
  "till": "till",
  "time": "Time",
  "time_ago": "{time} ago",
  "time_in_location": "Time in location",
  "time_to_complete": "Time to complete",
  "timezone": "Timezone",
  "timezone_default": "Default Timezone",
  "title": "Title",
  "today": "Today",
  "tomorrow": "Tomorrow",
  "total": "Total",
  "total_days": "Total days",
  "total_growth": "Total growth",
  "transfer": "Transfer",
  "tuesday": "Tuesday",
  "type": "Type",
  "type_files_supported": "{types} files are supported",
  "unit_of_time": "Unit",
  "unknown": "Unknown",
  "unpin": "Unpin",
  "unsaved_changes_may_be_lost_description": "If you leave now, any unsaved changes will be lost. Are you sure you want to exit?",
  "unsaved_changes_may_be_lost_title": "Unsaved changes may be lost",
  "untitled": "Untitled",
  "update": "Update",
  "update_progress": "Update progress",
  "updated": "Updated",
  "upload_file": "Upload file",
  "upload_file_drag_and_drop": "Drag file here",
  "upload_file_drag_and_drop_description": "Drag 'n' drop file here, or click to select files",
  "upload_logo": "Upload logo",
  "upload_logo_cta": "Choose a logo",
  "upload_new": "Upload new",
  "upload_photo": "Upload photo",
  "url": "URL",
  "url_alias": "URL alias",
  "use": "Use",
  "user_created": "User-created",
  "value": "Value",
  "value_number": "Value (number)",
  "verify": "Verify",
  "view": "View",
  "view_all": "View all",
  "view_all_responses": "View all responses",
  "view_history": "View history",
  "view_responses": "View responses",
  "visibility": "Visibility",
  "visible_to": "Visible to",
  "visual": "Visual",
  "waiting": "Waiting",
  "wednesday": "Wednesday",
  "week": "Week",
  "weeks": "Weeks",
  "weeks_short": "{count}w",
  "weight_custom": "Custom",
  "weight_default": "Default",
  "welcome": "Welcome",
  "word_file": "Word file",
  "words_in_comments": "Words in comments",
  "workflow": "Flow",
  "year_to_date": "Year to date",
  "years_short": "{count}y",
  "yes": "Yes",
  "yesterday": "Yesterday",
  "you": "You",
  "you_changes_were_saved": "Your changes were saved",
  "your_logo": "Your logo",
  "zoom_in": "Zoom in",
  "zoom_out": "Zoom out",
  "~": "~",
  "uploaded_by": "Uploaded by",
  "seconds_short": "{count}s",
  "sort_asc": "Sort ascending",
  "sort_desc": "Sort descending",
  "add_filter": "Add filter",
  "all_templates": "All templates",
  "rename_template_folder": "Rename folder",
  "delete_template_folder": "Delete folder",
  "delete_template_folder_named": "Delete folder “{title}”?",
  "folders_load_failed": "Couldn't load folders. Try again later.",
  "no_other_folders": "There are no other folders",
  "link_label": "Link label",
  "display_as_text": "Set label",
  "editor_align_left": "Align left",
  "editor_align_center": "Align center",
  "editor_align_right": "Align right",
  "editor_align_justify": "Justify",
  "editor_text_color": "Text color",
  "editor_background_color": "Highlight color",
  "editor_color_default": "Default",
  "editor_no_background": "No highlight",
  "editor_color_gray": "Gray",
  "editor_color_red": "Red",
  "editor_color_orange": "Orange",
  "editor_color_yellow": "Yellow",
  "editor_color_green": "Green",
  "editor_color_blue": "Blue",
  "editor_color_violet": "Violet",
  "editor_horizontal_rule": "Divider",
  "editor_clear_formatting": "Clear formatting",
  "editor_video": "Video",
  "editor_video_link": "Insert link",
  "editor_video_file": "Upload file",
  "editor_video_link_prompt": "YouTube, Vimeo or .mp4/.webm link",
  "editor_video_link_unsupported": "Paste a YouTube, Vimeo or direct .mp4/.webm link",
  "editor_video_remove": "Remove video",
  "editor_pdf": "PDF",
  "editor_pdf_remove": "Remove PDF"
}
